import Swal from "sweetalert2";
import { UseMutationResult, useMutation } from "react-query";
import { useQueryApiError, ResponseClientsUnlockService } from "../types";
import { useUser } from "./useUser";
import { deleteDeviceService } from "../services/deleteDeviceService";

type MutationParams = {
  serviceProvider: string;
  ciamId: string;
  deviceId: string;
  username: string;
};

type ClientsHookType = {
  useDeleteDevice: UseMutationResult<ResponseClientsUnlockService, useQueryApiError, MutationParams, unknown>;
};

export const useDeleteDeviceHook = (): ClientsHookType => {
  const { user: contextUser } = useUser();

  const useDeleteDevice = useMutation<
    ResponseClientsUnlockService,
    useQueryApiError,
    MutationParams,
    unknown
  >({
    mutationFn: async ({ serviceProvider, ciamId, deviceId, username }: MutationParams) => {
      return await deleteDeviceService({
        ciamId,
        deviceId,
        username,
        serviceProvider,
        token: contextUser.token
      });
    },
    onMutate: () => {
      Swal.fire({
        title: "...",
        html: "Please wait while the device is being deleted.",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
        timer: 5000
      });
    },
    onSuccess: () => {
      Swal.fire({
        title: "Device was deleted successfully!",
        text: "Device selected has been processed successfully.",
        icon: "success",
        width: "650px",
        confirmButtonText: "Ok"
      });
    },
    onError: () => {
      Swal.fire({
        title: "Error!",
        text: "An error occurred while processing the request.",
        icon: "error",
        width: "650px",
        confirmButtonText: "Ok"
      });
    }
  });

  return {
    useDeleteDevice
  };
};
